import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { PAGE_TYPES, SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import FormOptions from './components/_edit-options';
import CaptchaSvg from './components/captcha-svg';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('forms', {
  template: require('./template.html'),
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    profile() {
      return this._dropletType(this.droplet);
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    inProgress() {
      const d = this.display;
      return d.buttonSize || d.btnPaddingLeft || d.btnPaddingLeft || d.btnPaddingTop ||
      d.btnPaddingTop || d['border-width'] || d['border-radius'];
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzForm' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  mixins: [guid, cssGenerator],
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        labelSize: null,
        inputSize: null,
        btnWidth: null,
        btnMargins: null,
        buttonSize: null,
        btnPaddingTop: null,
        btnPaddingBottom: null,
        btnPaddingLeft: null,
        btnPaddingRight: null,
        btnWidthTop: null,
        btnWidthBottom: null,
        btnWidthLeft: null,
        btnWidthRight: null,
        inputBorderTop: null,
        inputBorderBottom: null,
        inputBorderLeft: null,
        inputBorderRight: null,
        inputRadiusTopLeft: null,
        inputRadiusTopRight: null,
        inputRadiusBottomLeft: null,
        inputRadiusBottomRight: null,
        btnRadiusTopLeft: null,
        btnRadiusTopRight: null,
        btnRadiusBottomLeft: null,
        btnRadiusBottomRight: null,
        captchawidth: null,
        captchaInputBorderTop: null,
        captchaInputBorderBottom: null,
        captchaInputBorderRight: null,
        captchaInputBorderLeft: null,
        captchaInputRadiusTopLeft: null,
        captchaInputRadiusTopRight: null,
        captchaInputRadiusBottomLeft: null,
        captchaInputRadiusBottomRight: null,
        width: null,
        perspective: null,
        btnLetterSpace: null,
        labelTextSpacing: null,
        'letter-spacing': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-width': null,
        'border-bottom-width': null,
        'border-top-left-radius': null,
        'border-top-right-radius': null,
        'border-bottom-left-radius': null,
        'border-bottom-right-radius': null,
        'padding-left': null,
        'padding-right: ': null,
        'padding-top:': null,
        'padding-bottom': null,
        'box-shadow': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-wide',
      showEditBubble: false,
      wait: null,
      showRevealClass: false,
    };
  },
  name: 'forms',
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    FormOptions,
    CaptchaSvg,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzForm',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
  },
  created() {
    this.checkNewValues();
    const pageType = this.currentPage.type;
    if (pageType !== 'dynamic page' && PAGE_TYPES.includes(pageType)) {
      this.$store.dispatch('addFormCount', { drp: this.droplet });
    }
  },
  mounted() {
    this.callCssGenerator();
    $(document).ready(() => {
      this.bindToolTip();
      this.bindValidation();
    });
    this.observeVisibility();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    checkNewValues() {
      const values = [];
      if (!this.droplet.successMessage) {
        values.push({ key: 'successMessage', value: 'Message Successfully Sent! We\'ll be in touch.' });
      }
      if (values.length > 0) {
        this.$store.dispatch('setNewDropletValues', {
          drp: this.droplet,
          vm: this,
          values,
        });
      }
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    debounce(fn, delay) {
      clearTimeout(this.wait);
      this.wait = setTimeout(() => {
        fn();
      }, delay);
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
    changeBubbleSize(size) {
      this.setBubbleSize = `dropletBubble-${size}`;
    },
    bindValidation() {
      const $form = $(this.$refs.drzForm);
      $form.drzFormValidate();
    },
    unBindValidation() {
      const $form = $(this.$refs.drzForm);
      $form.drzFormValidate.destroy($form);
    },
    bindToolTip() {
      const $tip = $(this.$refs.tooltip);
      $tip.drzTooltip();
    },
    unBindToolTip() {
      const $tip = $(this.$refs.tooltip);
      $tip.drzTooltip.destroy($tip);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/index.js